export default {
  wrapper: {
    padding: '25px',
    '@media screen and (max-width: 600px)': {
      padding: '16px',
    },
  },
};
